import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute';
import AdminRoute from '../components/AdminRoute';
import RoleRoute from '../components/RoleRoute';

import Dashboard from '../pages/Dashboard';
import Orders from '../pages/Orders';
import Products from '../pages/Products';
import PendingProducts from '../pages/PendingProducts';
import UserManagement from '../pages/UserManagement';
import CompanySetup from '../pages/CompanySetup';
import Settings from '../pages/Settings';
import Profile from '../pages/Profile';
import Messages from '../pages/Messages';
import Notifications from '../pages/Notifications';
import PriceRequests from '../pages/PriceRequests';
import ShippingCosts from '../pages/ShippingCosts';
import Treasury from '../pages/Treasury';
import Commissions from '../pages/Commissions';
import Social from '../pages/Social';
import Moderation from '../pages/Moderation';
import Advertising from '../pages/Advertising';

import ProductCreate from '../pages/ProductCreate';
import ProductDetails from '../pages/ProductDetails';
import ProductEdit from '../pages/ProductEdit';
import OrderCreate from '../pages/OrderCreate';
import OrderDetails from '../pages/OrderDetails';
import PrivateSales from '../pages/dashboard/drop';
import PrivateSaleDetails from '../pages/dashboard/drop/[id]';
import PrivateSaleOrders from '../pages/dashboard/drop/orders';
import OrderDetailsPrivateSales from '../pages/dashboard/drop/OrderDetails';
import SocialProfile from '../pages/SocialProfile';
import SocialProfileSetup from '../pages/SocialProfileSetup';
import CreateUser from '../pages/CreateUser';
import EditUser from '../pages/EditUser';
import ApiManagement from '../pages/ApiManagement';
import Invoices from '../pages/Invoices';
import Stock from '../pages/Stock';
import WarehouseOrders from '../pages/WarehouseOrders';
import TaskMonitor from '../pages/TaskMonitor';
import TokenGenerator from '../pages/TokenGenerator';
import IntegrationsSettings from '../pages/IntegrationsSettings';
import StoreSettings from '../pages/settings/store';
import MarketplaceSettings from '../pages/dashboard/marketplace/settings';
import CommissionManagement from '../pages/CommissionManagement';
import PaymentSettings from '../pages/settings/payments';
import Vouchers from '../pages/dashboard/vouchers';
import PrivateSalesCheckout from '../pages/PrivateSalesCheckout';
import ReviewsPage from '../pages/dashboard/reviews';
import MarketplaceClients from '../pages/marketplace/MarketplaceClients';
import MarketplaceClientDetails from '../pages/marketplace/MarketplaceClientDetails';
import MarketplaceClientEdit from '../pages/marketplace/MarketplaceClientEdit';
import MarketplaceOrders from '../pages/marketplace/MarketplaceOrders';
import MarketplaceOrderDetails from '../pages/marketplace/MarketplaceOrderDetails';
import Recolhas from '../pages/marketplace/Recolhas';
import Cancellations from '../pages/marketplace/Cancellations';
import UserDetails from '../pages/UserDetails';
import PendingProductDetails from '../pages/PendingProductDetails';
import PendingProductEdit from '../pages/PendingProductEdit';
import Pricebench from '../pages/dashboard/pricebench';
import MyShipments from '../pages/shipping/MyShipments';
import ShippingSettings from '../pages/shipping/ShippingSettings';
import CreateShipment from '../pages/shipping/CreateShipment';
import ShippingReport from '../pages/shipping/ShippingReport';
import Pickups from '../pages/shipping/Pickups';
import ExternalOrders from '../pages/multicanal/ExternalOrders';
import ChannelActivations from '../pages/multicanal/ChannelActivations';
import ChannelSettings from '../pages/multicanal/ChannelSettings';
import AmazonCallback from '../pages/multicanal/AmazonCallback';
import ProductSubmission from '../pages/multicanal/ProductSubmission';
import ProductApproval from '../pages/multicanal/ProductApproval';
import MyProducts from '../pages/multicanal/MyProducts';
import { ApiKeys } from '../pages/settings/ApiKeys';
import Import from '../pages/import/Import';
import { ShopifyCallback } from '../pages/multicanal/shopify/ShopifyCallback';
import UserRoles from '../pages/settings/UserRoles';

export default function DashboardRoutes() {
  return (
    <Routes>
      {/* Dashboard Home */}
      <Route index element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Dashboard />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Reviews Route */}
      <Route path="reviews" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <ReviewsPage />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Integrations Routes */}
      <Route path="integrations/settings" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <IntegrationsSettings />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Product Routes */}
      <Route path="products" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Products />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="products/pending" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <PendingProducts />
          </Suspense>
        </AdminRoute>
      } />

      <Route path="products/pending/:id" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <PendingProductDetails />
          </Suspense>
        </AdminRoute>
      } />

      <Route path="products/pending/:id/edit" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <PendingProductEdit />
          </Suspense>
        </AdminRoute>
      } />

      <Route path="products/create" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <ProductCreate />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="products/:id" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <ProductDetails />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="products/:id/edit" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <ProductEdit />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Vouchers Route */}
      <Route path="vouchers" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Vouchers />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Order Routes */}
      <Route path="orders" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Orders />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="orders/create" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <OrderCreate />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="orders/:id" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <OrderDetails />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="orders/:id/edit" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <OrderCreate />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Private Sales Routes */}
      <Route path="drop" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateSales />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="drop/:id" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateSaleDetails />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="drop/orders" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateSaleOrders />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="drop/orders/:id" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <OrderDetailsPrivateSales />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="drop/checkout" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateSalesCheckout />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Marketplace Routes */}
      <Route path="marketplace/clients" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <MarketplaceClients />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="marketplace/clients/:id" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <MarketplaceClientDetails />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="marketplace/clients/:id/edit" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <MarketplaceClientEdit />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="marketplace/orders" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <MarketplaceOrders />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="marketplace/orders/:id" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <MarketplaceOrderDetails />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="marketplace/recolhas" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Recolhas />
          </Suspense>
        </AdminRoute>
      } />

      <Route path="marketplace/settings" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <MarketplaceSettings />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="marketplace/cancellations" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Cancellations />
          </Suspense>
        </AdminRoute>
      } />

      {/* Fulfillment Routes */}
      <Route path="fulfillment/stock" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Stock />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="fulfillment/warehouse-orders" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <WarehouseOrders />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Shipping Routes */}
      <Route path="shipping">
        <Route index element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <MyShipments />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="settings" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <ShippingSettings />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="create" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <CreateShipment />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="report" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <ShippingReport />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="pickups" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <Pickups />
            </Suspense>
          </PrivateRoute>
        } />
      </Route>

      {/* Social Routes */}
      <Route path="social" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Social />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="social/profile/:id" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <SocialProfile />
          </Suspense>
        </PrivateRoute>
      } />

      <Route path="social/profile/setup" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <SocialProfileSetup />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Messages Route */}
      <Route path="messages" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Messages />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Notifications Route */}
      <Route path="notifications" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Notifications />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Profile Route */}
      <Route path="profile" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Profile />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Admin Routes */}
      <Route path="users" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <UserManagement />
          </Suspense>
        </AdminRoute>
      } />

      <Route path="users/:id" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <UserDetails />
          </Suspense>
        </AdminRoute>
      } />

      <Route path="users/:id/edit" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <EditUser />
          </Suspense>
        </AdminRoute>
      } />

      <Route path="settings/api-keys" element={
        <RoleRoute path="/dashboard/settings/api-keys">
          <Suspense fallback={<div>Loading...</div>}>
            <ApiKeys />
          </Suspense>
        </RoleRoute>
      } />

      <Route path="settings/user-roles" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <UserRoles />
          </Suspense>
        </AdminRoute>
      } />

      <Route path="users/create" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <CreateUser />
          </Suspense>
        </AdminRoute>
      } />

      <Route path="companies" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <CompanySetup />
          </Suspense>
        </AdminRoute>
      } />
      <Route path="price-requests" element={<AdminRoute><Suspense fallback={<div>Loading...</div>}><PriceRequests /></Suspense></AdminRoute>} />
      <Route path="shipping" element={<AdminRoute><Suspense fallback={<div>Loading...</div>}><ShippingCosts /></Suspense></AdminRoute>} />
      <Route path="commissions" element={<AdminRoute><Suspense fallback={<div>Loading...</div>}><Commissions /></Suspense></AdminRoute>} />
      <Route path="treasury" element={<AdminRoute><Suspense fallback={<div>Loading...</div>}><Treasury /></Suspense></AdminRoute>} />
      <Route path="moderation" element={<AdminRoute><Suspense fallback={<div>Loading...</div>}><Moderation /></Suspense></AdminRoute>} />
      <Route path="advertising" element={<PrivateRoute><Suspense fallback={<div>Loading...</div>}><Advertising /></Suspense></PrivateRoute>} />

      {/* Multicanal Routes */}
      <Route path="multicanal/external-orders" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <ExternalOrders />
          </Suspense>
        </PrivateRoute>
      } />
      <Route path="multicanal/activations" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <ChannelActivations />
          </Suspense>
        </PrivateRoute>
      } />
      <Route path="multicanal/settings" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <ChannelSettings />
          </Suspense>
        </AdminRoute>
      } />
      <Route path="multicanal/amazon/callback" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <AmazonCallback />
          </Suspense>
        </PrivateRoute>
      } />
      <Route path="multicanal/products/submit" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <ProductSubmission />
          </Suspense>
        </PrivateRoute>
      } />
      <Route path="multicanal/products/my" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <MyProducts />
          </Suspense>
        </PrivateRoute>
      } />
      <Route path="multicanal/products/approval" element={
        <AdminRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <ProductApproval />
          </Suspense>
        </AdminRoute>
      } />
      <Route path="multicanal/shopify/callback" element={
        <Suspense fallback={<div>Loading...</div>}>
          <ShopifyCallback />
        </Suspense>
      } />

      {/* Pricebench Route */}
      <Route path="pricebench" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Pricebench />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Import Routes */}
      <Route path="import" element={
        <Suspense fallback={<div>Loading...</div>}>
          <Import />
        </Suspense>
      } />

      {/* Settings Routes */}
      <Route path="settings">
        <Route path="users" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <UserManagement />
            </Suspense>
          </PrivateRoute>
        } />

        <Route path="users/create" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <CreateUser />
            </Suspense>
          </PrivateRoute>
        } />

        <Route path="moderation" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <Moderation />
            </Suspense>
          </PrivateRoute>
        } />

        <Route index element={
          <AdminRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <StoreSettings />
            </Suspense>
          </AdminRoute>
        } />
        <Route path="store" element={
          <AdminRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <StoreSettings />
            </Suspense>
          </AdminRoute>
        } />
        <Route path="payments" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <PaymentSettings />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="profile" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <Profile />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="apis" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <ApiManagement />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="shipping" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <ShippingCosts />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="price-requests" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <PriceRequests />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="tasks" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <TaskMonitor />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="token" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <TokenGenerator />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="integrations" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <IntegrationsSettings />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="api-management" element={
          <PrivateRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <ApiManagement />
            </Suspense>
          </PrivateRoute>
        } />
        <Route path="api-keys" element={
          <AdminRoute>
            <Suspense fallback={<div>Loading...</div>}>
              <ApiKeys />
            </Suspense>
          </AdminRoute>
        } />
      </Route>

      {/* Other Routes */}
      <Route path="invoices" element={
        <PrivateRoute>
          <Suspense fallback={<div>Loading...</div>}>
            <Invoices />
          </Suspense>
        </PrivateRoute>
      } />

      {/* Fallback Route */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
